import { Component, Input, OnInit } from "@angular/core";
import { OwlOptions } from "ngx-owl-carousel-o";
import { ToastrService } from "ngx-toastr";
import Swal from "sweetalert2";
import { BaseService } from "../base.service";
import * as config from "../../../assets/grid_config.json";
import { environment } from "../../../environments/environment";
import { forkJoin } from "rxjs";

@Component({
  selector: "app-grid-slider-list",
  templateUrl: "./grid-slider-list.component.html",
  styleUrls: ["./grid-slider-list.component.css"],
})
export class GridSliderListComponent implements OnInit {
  shimmerStatus = {
    Interviews: false,
    recommended: false,
    continueWatching: false,
    trendingContent: false,
  };
  trendingContent: any = [];
  isContent = true;
  imageType = "landscape";
  gridConfig: any = (config as any).default;
  @Input() content: any;
  continueWatchingData: any = [];
  apiParam = { slug: "home", limit: 2, offset: 0 };
  param = { limit: 20, offset: 0 };
  recommendedData: any = [];
  popularVideos: any = [];
  url: any;
  constructor(public service: BaseService, private toastr: ToastrService) { }

  ngOnInit(): void {
    if (this.content === "continueWatchingData") {
      this.shimmerStatus.continueWatching = true;
      this.getContinueWatching();
    } else if (this.content === "recommendedData") {
      this.shimmerStatus.recommended = true;
      this.getRecommended();
    } else if (this.content === this.gridConfig.grid_content.interviewsTitle) {
      this.shimmerStatus.Interviews = true;
      this.setData();
    } else if (
      this.content === this.gridConfig.grid_content.trendingContentsTitle
    ) {
      this.shimmerStatus.trendingContent = true;
      this.trendingAudio();
    }
  }
  setData() {
    if (localStorage.getItem(environment.pagesLocalStorageKey)) {
      const localdata = JSON.parse(
        localStorage.getItem(environment.pagesLocalStorageKey)
      );

      const index = localdata
        .map((el) => {
          return el.hasOwnProperty("popular");
        })
        .indexOf(true);
      if (index != -1) {
        this.popularVideos = localdata[index]["popular"];
        this.shimmerStatus.Interviews = false;
      } else {
        this.getPopularData();
      }
    } else {
      this.getPopularData();
    }
  }
  playOff() {
    this.service.modelData = undefined;
    this.service.playerReady = false;
  }
  toprated: OwlOptions = {
    loop: false,
    autoplay: false,
    mouseDrag: true,
    autoWidth: true,
    touchDrag: true,
    pullDrag: true,
    dots: false,
    navSpeed: 700,
    smartSpeed: 1,
    skip_validateItems: true,
    navText: ['<i class="mdi mdi-arrow-left"></i>', '<i class="mdi mdi-arrow-right"></i>'],
    responsive: {
      0: {
        items: 3.5,
      },
      380: {
        items: 3.5,
      },
      450: {
        items: 4.5,
      },
      650: {
        items: 4.5,
      },
      910: {
        items: 6,
      },
      1108: {
        items: 6,
      },
      1230: {
        items: 6,
      },
      1257: {
        items: 6,
      },
    },
    nav: true,
  };

  upcomingShow: OwlOptions = {
    loop: false,
    mouseDrag: true,
    touchDrag: true,
    autoWidth: true,
    pullDrag: false,
    dots: false,
    navSpeed: 700,
    smartSpeed: 1,
    skip_validateItems: true,

    navText: ['<i class="mdi mdi-arrow-left"></i>', '<i class="mdi mdi-arrow-right"></i>'],
    responsive: {
      0: {
        items: 3.5,
      },
      380: {
        items: 3.5,
      },
      450: {
        items: 4.5,
      },
      650: {
        items: 4.5,
      },
      1366: {
        items: 4,
      },
      1840: {
        items: 5,
      },
    },
    nav: true,
  };
  recommended: OwlOptions = {
    loop: false,
    autoplay: false,
    mouseDrag: true,
    autoWidth: true,
    touchDrag: true,
    pullDrag: true,
    dots: false,
    navSpeed: 700,
    smartSpeed: 1,
    skip_validateItems: true,
    navText: ['<i class="mdi mdi-arrow-left"></i>', '<i class="mdi mdi-arrow-right"></i>'],
    responsive: {
      0: {
        items: 3.5,
      },
      380: {
        items: 3.5,
      },
      450: {
        items: 4.5,
      },
      650: {
        items: 4.5,
      },
      1366: {
        items: 4,
      },
      1840: {
        items: 5,
      },
    },
    nav: true,
  };
  getContinueWatching() {
    const sendData = {
      apiParam: this.apiParam,
      device_type: "web",
    };
    this.service.continueWatching(sendData).subscribe(
      (data: any) => {
        if (data.content.length > 0) {
          this.continueWatchingData = data.content;
          this.service.listStatus = true;
          this.shimmerStatus.continueWatching = false;
        } else {
          this.service.listStatus = false;
        }
      },
      (err) => {
        if (err) {
          setTimeout(() => {
            this.shimmerStatus.continueWatching = false;
            this.service.listStatus = false;
          }, 3000);
        }
      }
    );
  }
  getRecommended() {
    var recommended = [];
    var mostPopular = [];
    this.service.recommended(this.param).subscribe((data: any) => {
      recommended = data;
    });
    this.service.mostPopular(this.param).subscribe((data: any) => {
      if (this.recommendedData.length == 0) {
        mostPopular = data;
      }
    });
    if (recommended.length > 0) {
      this.recommendedData = recommended;
      this.shimmerStatus.recommended = false;
    } else {
      this.recommendedData = mostPopular;
      this.shimmerStatus.recommended = false;
    }
  }
  getPopularData() {
    forkJoin({
      // responseOne: this.service.recommended(this.param),
      // responseTwo: this.service.mostPopular(this.param),
      responseThree: this.service.popularContent(this.param),
    }).subscribe(
      ({ responseThree }) => {
        this.shimmerStatus.Interviews = false;


        this.url = "top-rated-contents";
        this.popularVideos = responseThree.results;

        if (this.popularVideos.length > 0) {
          this.service.contentPopular = true;
        } else {
          this.service.contentPopular = false;
          this.shimmerStatus.Interviews = false;
          this.shimmerStatus.trendingContent = false;
        }
      },
      (err) => {
        if (err) {
          // this.service.contentPopular = false;
          this.shimmerStatus.Interviews = false;
          this.shimmerStatus.trendingContent = false;
        }
      }
    );
  }
  trendingAudio() {
    this.service.trendingContentAudio(this.param).subscribe(
      (data: any) => {
        this.trendingContent = data.results;
        this.shimmerStatus.trendingContent = false;
      },
      (err) => {
        if (err) {
          setTimeout(() => {
            this.shimmerStatus.trendingContent = false;
          }, 3000);
          // this.toastr.error(err.error.message);
        }
      }
    );
  }
  deleteContinueWatching(data) {
    if (data === "clear_all") {
      Swal.fire({
        title: "Are you sure",
        text: "you want to remove all items?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, remove it!",
        allowOutsideClick: false,
      }).then((result) => {
        if (result.isConfirmed) {
          this.service.deleteContinueWatching(data).subscribe(
            (res: any) => {
              if (res) {
                this.continueWatchingData = [];
                this.service.listStatus = false;
                this.toastr.success(res.message, "Success!", {
                  closeButton: true,
                });
              }
            },
            (err) => {
              this.toastr.error(err.error.message, "OOPS!", {
                closeButton: true,
              });
            }
          );
        }
      });
    } else {
      Swal.fire({
        title: "Are you sure",
        text: "You want to remove this?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, remove it!",
        allowOutsideClick: false,
      }).then((result) => {
        if (result.isConfirmed) {
          this.service.deleteContinueWatching(data).subscribe(
            (res: any) => {
              if (res) {
                this.continueWatchingData.splice(
                  this.continueWatchingData.findIndex(
                    (ele) => ele.public_id == data
                  ),
                  1
                );
                if (this.continueWatchingData.length === 0) {
                  this.service.listStatus = false;
                }
                this.toastr.success(res.message, "Success!", {
                  closeButton: true,
                });
              }
            },
            (err) => {
              this.toastr.error(err.error.message, "OOPS!", {
                closeButton: true,
              });
            }
          );
        }
      });
    }
  }

  ngOnDestroy() {
    Swal.close();
  }
}
